<form [formGroup]="form">
  <header>
    <h1 mat-dialog-title>
      <div class="placeholder">
        {{ isNewQuestion ? 'New Question' : 'Update Question' }}
      </div>
    </h1>
  </header>
  <div mat-dialog-content>
    <table class="table-striped table-td-border-right table-no-border-bottom question-box">
      <tr>
        <td colspan="3">
          <app-entity-type-picker
            [entitiesToRender]="sortedEntities"
            [form]="form">
          </app-entity-type-picker>
        </td>
      </tr>
      <tr>
        <td colspan="1">
          <mat-label>Question</mat-label>
          <textarea
            class="question-input-field"
            formControlName="displayName"
            placeholder="e.g. What is the candidate's name?">
          </textarea>
        </td>
      </tr>
      <tr> <td colspan="2">
        <mat-label>Destination</mat-label>
        <input class="destination-input-field" type="text" formControlName="action" placeholder="bullhorn.Candidate.firstName">
      </td></tr>
    </table>

  </div>
  <section  mat-dialog-actions class="footer-btns">
    <button class="danger-btn-hover" (click)="discardLocalChanges($event)" tabindex="0">cancel
    </button>
    <button type="submit" (click)="saveQuestion()" [disabled]="!allowSave">save
    </button>
  </section>
</form>
